import React from 'react'

const ReactLogo = () => {
    return (
        <div>
            <div className="react-container">
                <span className="react-logo">
                    
                    <span className="nucleo"></span>
                </span>
            </div>
        </div>
    )
}

export default ReactLogo